// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "admin-260408-1/static/css/" + chunkId + "." + {"451":"6e32d4a8","652":"ffa32799","1386":"79e2a195","1672":"2042e2f7","2638":"ffa32799","5934":"79e2a195","6531":"2042e2f7","9210":"ffa32799"}[chunkId] + ".chunk.css";
};